import {
    UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS,
    UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED,
    RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN,
    LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN,
    NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetUpdateWalletTransactionStatusAdmin = () => {
    return { type: RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN };
};

const getUpdateWalletTransactionStatusAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN });
    await partnerServices
        .post("updateWalletTransactionStatus", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(getUpdateWalletTransactionsuccess(res.data));
                    break;
                case "success":
                    dispatch(getUpdateWalletTransactionsuccess(res.data));
                    break;
                default:
                    dispatch(getUpdateWalletTransactionFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN, payload: err });
        });
};
function getUpdateWalletTransactionsuccess(data) {
    return {
        type: UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS,
        payload: data,
    };
}
function getUpdateWalletTransactionFailed(data) {
    return {
        type: UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED,
        payload: data,
    };
}

export { resetUpdateWalletTransactionStatusAdmin, getUpdateWalletTransactionStatusAdminLists };
